/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames, mergeStyleSets } from "@microsoft/shifts-ui-core";

type CrossLocationRequestStyles = "stack" | "shift" | "member";
/**
 * Gets the 'CrossLocationRequestDetails' component CSS class names.
 * @returns The 'CrossLocationRequestDetails' component CSS class names.
 */
export const getClassNames = (): ComponentClassNames<CrossLocationRequestStyles> => {
    return mergeStyleSets({
        stack: {
            padding: "0.5rem 1.5rem"
        },
        shift: {
            height: "100%",
            padding: "0"
        },
        member: {
            padding: "0.2rem 0"
        }
    });
};
